@if (isLoading) {
  <div class="step-loading">
    <mat-spinner style="height: 50px !important"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="filter-box">
    <div class="action-group">
      @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <mat-checkbox
          (change)="setAll($event.checked)"
          [checked]="allSelected"
          [color]="'primary'"
        >Select all</mat-checkbox>
      }
      @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <button
          mat-stroked-button
          class="download-multiple"
          (click)="downloadMultiple()"
          [disabled]="disableButtonDownload()"
          >
          <mat-icon>file_download</mat-icon>Download{{ "(" + selectedCount + ")" }}
        </button>
      }
    </div>
    <div class="filter-group">
      <app-enhancement-variants-change-action
        [product]="product"
        [enhancementVariantIdSelected]="enhancementVariantIdSelected"
        (enhancementVariantChanged)="onEnhancementVariantChanged($event)"
      ></app-enhancement-variants-change-action>
      <app-label-data-product-create-action
        [selectedProducts]="[product]"
      ></app-label-data-product-create-action>
      <app-download-itt-action
        [product]="product"
        [assetType]="'post-asset'"
      ></app-download-itt-action>
      <app-create-outputs-icon-action
        [product]="product"
        [selectedPostAssetIds]="getSelectedPostAssetIds()"
      ></app-create-outputs-icon-action>
      <app-view-mode-action
        [postView]="postView"
        (postViewChange)="postView = $event; onViewChange()"
      ></app-view-mode-action>
    </div>
  </div>
}

@for (item of content; track item; let i = $index) {
  <div [ngClass]="{ loading: isLoading }">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title style="justify-content: space-between">
          <div class="touch">
            <div class="touch-info">
              <div class="touch-title">{{ item.name }}</div>
            </div>
          </div>
          <app-transfer-placeholder-action
            [touchId]="item.id"
            [content]="content"
            [quantitySelected]="item.quantitySelected"
          ></app-transfer-placeholder-action>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="step-list"
        [ngStyle]="{ 'grid-template-columns': 'repeat(' + colPerScreen + ',minmax(0,1fr))' }"
        >
        @for (asset of item.assets; track asset) {
          <app-card-item
            [showExternalStatus]="authService.hasPermission(Permission.PostAssetsPreRelease)"
            [dataType]="'postProduction'"
            [data]="asset"
            [editCallback]="editCallback"
            [touchId]="item.id"
            [releasedInCollection]="product.releasedInCollection"
            (done)="updateRowHeight()"
            (selectedCheckbox)="selectedCard($event)"
          ></app-card-item>
        }
      </div>
      @if (
        authService.hasPermission(Permission.PostAssetsPreRelease) &&
        product.masterSuiteEnhancementVariantId == null
        ) {
        <div
          class="no-selects-text"
          >
          No Enhancement Variant is Applied
        </div>
      }
    </mat-expansion-panel>
  </div>
}
